export default "__VITE_ASSET__Dc$dKWJk__"